import { BotFeatures } from '@feedyou-ai/feedbot-schema'

export function isStepPreprocessorEnabled(sdkFeatures: BotFeatures[]): boolean {
  return sdkFeatures.includes(BotFeatures.STEP_PREPROCESSOR)
}

export function isCustomStepPreprocessorEnabled(sdkFeatures: BotFeatures[]): boolean {
  return sdkFeatures.includes(BotFeatures.PROMPT_STEP_CUSTOM_PREPROCESSOR_EXPRESSIONS_OR_CODE)
}
